import { useQuery } from '@tanstack/react-query';
import { AdvancedFilterPanel } from '@/components/common/AdvancedFilter';
import { zonalManagersQueryOptions } from '@/features/users/api/users.api';
import { getFilterPanelProps, type UrlSyncedFilters } from '@/hooks/useUrlSyncedFilters';
import { getDateFromToFilterFields, getZonalManagerFilterField } from '@/utils/filterFields';

const COVERING_WORK_FROM_FILTER_KEY = 'trnDateFrom';
const COVERING_WORK_TO_FILTER_KEY = 'trnDateTo';

interface BatchFilterPanelProps {
  filters: UrlSyncedFilters;
}

export function BatchFilterPanel({ filters }: BatchFilterPanelProps) {
  const { data: zonalManagers } = useQuery(zonalManagersQueryOptions());

  return (
    <AdvancedFilterPanel
      fields={[
        ...getDateFromToFilterFields({ labelPrefix: 'Published' }),
        ...getDateFromToFilterFields({
          fromKey: COVERING_WORK_FROM_FILTER_KEY,
          toKey: COVERING_WORK_TO_FILTER_KEY,
          labelPrefix: 'Covering Work',
        }),
        getZonalManagerFilterField(zonalManagers),
      ]}
      {...getFilterPanelProps(filters)}
    />
  );
}
